import React from 'react';
import { MessageCircle, Mail, Phone } from 'lucide-react';
import { CONTACT_PHONE, CONTACT_EMAIL, WHATSAPP_LINK } from '../constants';
import { Logo } from './Logo';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-50 text-slate-600 py-16 border-t border-slate-200">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="mb-4 opacity-90">
              <Logo variant="light" />
            </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              Automatización Inteligente con IA de Vanguardia. Transformamos la operativa de tu negocio para que recuperes tu tiempo.
            </p>
          </div>

          {/* Explorar */}
          <div>
            <h4 className="text-slate-900 font-bold text-lg mb-6">Explorar</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="/" className="hover:text-emerald-700 transition-colors">Inicio</a></li>
              <li><a href="/blog/" className="hover:text-emerald-700 transition-colors">Blog</a></li>
              <li><a href="#marketing-ia" className="hover:text-emerald-700 transition-colors">Marketing IA</a></li>
              <li><a href="/clinicas-centros-agenda" className="hover:text-emerald-700 transition-colors">Clínicas y agenda</a></li>
              <li><a href="/centros-estetica-belleza" className="hover:text-emerald-700 transition-colors">Estética y belleza</a></li>
              <li><a href="/agentes-ventas-ia" className="hover:text-emerald-700 transition-colors">Agentes de ventas IA</a></li>
              <li><a href="/integraciones-software-ia" className="hover:text-emerald-700 transition-colors">Integraciones</a></li>
              <li><a href="#contacto" className="hover:text-emerald-700 transition-colors">Contactar</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-slate-900 font-bold text-lg mb-6">Legal</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="/privacidad" className="hover:text-emerald-700 transition-colors">Política de Privacidad</a></li>
              <li><a href="/eliminacion-datos" className="hover:text-emerald-700 transition-colors">Eliminación de Datos</a></li>
              <li><span className="text-slate-400 cursor-not-allowed">Términos y Condiciones</span></li>
              <li><span className="text-slate-400 cursor-not-allowed">Cumplimiento RGPD</span></li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-slate-900 font-bold text-lg mb-6">Contacto</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-secondary" />
                <button className="hover:text-emerald-700 transition-colors text-left">{CONTACT_EMAIL}</button>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-secondary" />
                <a href={`tel:${CONTACT_PHONE.replace(/\s/g, '')}`} className="hover:text-emerald-700 transition-colors">{CONTACT_PHONE}</a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={16} className="text-secondary" />
                <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-green-600 hover:text-green-500 font-medium">Contactar por WhatsApp</a>
              </li>
              <li className="text-slate-500 pl-7">
                Horario: L-V 9:00-18:00 CET
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} ANCORA AUTOMATIONS - Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>
  );
};
